/**
 * Authentication-related constants
 */

export const AUTH_STORAGE_KEYS = {
  RETURN_URL: 'authReturnTo'
};

export const DEFAULT_ROUTES = {
  DASHBOARD: '/dashboard',
  HOME: '/home',
  INSTALL: '/install',
  LOGIN: '/login'
};

export const AUTH_ERRORS = {
  STORAGE_FAILED: 'Failed to access browser storage',
  INVALID_STATE: 'Invalid authentication state'
};
